/* eslint-disable react/style-prop-object */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import Badge from 'base-ui/dist/Badge';
import messages from './messages';

function Campaign({ price, campaign, layout }) {
  if (layout === 'unycos') {
    return (
      <div className="metas end-xs">
        <Badge className="end-xs red-bg white-color text-uppercase">
          {campaign.title ? campaign.title : ' '}
        </Badge>
        <span className="meta end-xs red-color">
          {campaign.discount}
          %
          <FormattedMessage {...messages.disc} />
          {' '}
          <del>
            <FormattedNumber
              value={price.eur}
              currency="EUR"
              style="currency"
              minimumFractionDigits={2}
            />
          </del>
        </span>
      </div>
    );
  }
  return (
    <Fragment>
      <strong
        className="badge titles-bg cyber white-color display-block"
        title={campaign.short_summary}
      >
        {campaign.title && campaign.title}
        {!campaign.title && ' '}
      </strong>
      <span className="red-color display-block full end-xs start-sm">
        {campaign.discount}
        %
        <FormattedMessage {...messages.disc} />
        {' '}
        <del>
          <FormattedNumber
            value={price.eur}
            currency="EUR"
            style="currency"
            minimumFractionDigits={2}
          />
        </del>
      </span>
    </Fragment>
  );
}

Campaign.defaultProps = {
  price: {},
  campaign: {},
};

Campaign.propTypes = {
  price: PropTypes.shape({
    eur: PropTypes.number
  }),
  campaign: PropTypes.shape({
    title: PropTypes.string,
    discount: PropTypes.string,
    short_summary: PropTypes.string
  }),
  layout: PropTypes.object,
};

export default Campaign;
